import { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import { UseMotorRouting } from "./UseMotorRouting";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import Detail from "../../main/detail/Detail";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import CheckIcon from "@mui/icons-material/Check";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "leaflet/dist/leaflet.css";
import { useSnackbar } from "notistack";
import AllRoutsLists from "./AllRoutsLists";
import AllMapContainer from "./AllMapContainer";
import { toSolar } from "jdate-convert";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function MotorRouting() {
  const { enqueueSnackbar } = useSnackbar();
  const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];
  const [valueDate, setValueDate] = useState();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [oneOrderSearch, setOneOrderSearch] = useState();
  const [zoneIndex, setZoneIndex] = useState();

  const {
    GetLocations,
    GetRoutes,
    getParts,
    EditSendGroup,
    GetOrderByLogesticId,
    AutoRout,
  } = UseMotorRouting();
  const { myPc, refresh } = UseMyPC();
  const [locations, setLocations] = useState();
  const [routes, setRoutes] = useState();
  const [locationRout, setLocationRout] = useState({
    id: undefined,
    zoneIndex: undefined,
  });
  const [sendNewLoc, setSendNewLoc] = useState({
    id: undefined,
    latitude: 35.7009,
    longitude: 51.391241,
  });
  const { isSmall } = useBreakpoints();

  const [orderDetail, setOrderDetail] = useState();
  const [changeZoom, setChangeZoom] = useState(false);
  const [parts, setParts] = useState();
  const [isSearch, setIsSearch] = useState(false);
  const [assigned, setAssigned] = useState(false);
  const [openAutoRout, setOpenAutoRout] = useState(false);
  const [filters, setFilters] = useState({
    deliveryDate: new Date().toJSON().slice(0, 10),
    deliveryPart: undefined,
  });
  const [orderModel, setOrderModel] = useState({
    deliveryDate: new Date().toJSON().slice(0, 10),
    deliveryPart: undefined,
    logesticID: undefined,
    orderID: undefined,
  });

  const [open, setOpen] = useState({
    show: false,
    model: undefined,
  });

  useEffect(() => {
    setProgress(true);
    getParts(myPc, (parts) => {
      setOrderModel({
        ...orderModel,
        deliveryPart: parts.parts[0].id,
      });
      setFilters({
        ...filters,
        deliveryPart: parts.parts[0].id,
      });
      setParts(parts);
    });
  }, [myPc]);

  useEffect(() => {
    if (filters.deliveryDate && filters.deliveryPart) {
      setOneOrderSearch("");
      setLocationRout({
        id: undefined,
        zoneIndex: undefined,
      });
      setChangeZoom(true);
      setAssigned(false);
      setOrderModel({
        ...orderModel,
        logesticID: undefined,
        orderID: undefined,
      });
      setProgress(true);
      GetRoutes(filters.deliveryDate, filters.deliveryPart, (Routes) => {
        setChangeZoom(false);
        if (Routes) {
          setRoutes(Routes);
        } else {
          setRoutes();
        }
      });
      GetLocations(
        filters.deliveryDate,
        filters.deliveryPart,
        (Locations) => {
          if (Locations) {
            setLocations(Locations);
          } else {
            setLocations();
          }
        },
        true
      );
    }
  }, [filters]);

  useEffect(() => {
    refresh();
  }, []);

  useEffect(() => {
    if (valueDate) {
      let newValueStart = valueDate?.toDate?.().toLocaleDateString("en-CA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
      setOrderModel({ ...orderModel, deliveryDate: newValueStart });
      setFilters({ ...filters, deliveryDate: newValueStart });
    }
  }, [valueDate]);

  useEffect(() => {
    if (locationRout.zoneIndex && locationRout.id && assigned) {
      EditSendGroup(locationRout, (callback) => {
        refreshPage();
      });
    }
  }, [locationRout]);

  useEffect(() => {
    if (orderModel.logesticID) {
      setProgress(true);
      GetOrderByLogesticId(orderModel, (callback) => {
        setOrderModel({
          ...orderModel,
          orderID: callback.id,
          logesticID: undefined,
        });
        // setOpen({ ...open, model: callback });
      });
    }
  }, [orderModel]);

  function refreshPage() {
    GetRoutes(filters.deliveryDate, filters.deliveryPart, (Routes) => {
      if (Routes) {
        setRoutes(Routes);
      } else {
        setRoutes();
      }
    });
    GetLocations(
      filters.deliveryDate,
      filters.deliveryPart,
      (Locations) => {
        if (Locations) {
          setLocations(Locations);
        } else {
          setLocations();
        }
      },
      false
    );
  }

  return (
    <Detail
      breadChilds={{
        title: "لجستیک",
        childs: [{ name: msActiveMenu.pageTitle, url: "/motorrouting" }],
      }}
    >
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={openAutoRout}
        onClose={() => setOpenAutoRout(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          آیا از روتینگ هوشمند اطمینان دارید؟
        </DialogTitle>
        <DialogActions>
          <Button
            sx={{ color: "#565656 !important" }}
            onClick={() => {
              setOpenAutoRout(false);
              setProgress(true);
              AutoRout(filters, (Locations) => {
                setProgress(false);
                if (Locations) {
                  GetRoutes(
                    filters.deliveryDate,
                    filters.deliveryPart,
                    (Routes) => {
                      setChangeZoom(false);
                      if (Routes) {
                        setRoutes(Routes);
                      } else {
                        setRoutes();
                      }
                    }
                  );
                  GetLocations(
                    filters.deliveryDate,
                    filters.deliveryPart,
                    (Locations) => {
                      if (Locations) {
                        setLocations(Locations);
                      } else {
                        setLocations();
                      }
                    },
                    false
                  );
                } else {
                }
              });
            }}
          >
            بله
          </Button>
          <Button
            color="secondary"
            onClick={() => {
              setProgress(false);
              setOpenAutoRout(false);
            }}
          >
            خیر
          </Button>
        </DialogActions>
      </Dialog>
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexDirection: isSmall ? "column" : "row",
            alignItems: isSmall ? "flex-start" : "center",
            gap: 2,

            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 3,
              zIndex: 1000,
            }}
          >
            <DatePicker
              // highlightToday={false}
              onOpenPickNewDate={false}
              weekDays={weekDays}
              calendar={persian}
              locale={persian_fa}
              format="YYYY-MM-DD"
              value={filters.deliveryDate ? toSolar(filters.deliveryDate) : ""}
              onChange={setValueDate}
              render={
                <TextField
                  sx={{ input: { textAlign: "center" } }}
                  variant="outlined"
                  size="small"
                  fullWidth
                  label="تاریخ"
                />
              }
            />
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {parts &&
                parts.parts.map((part) => {
                  return (
                    <Button
                      sx={{ width: "100px" }}
                      startIcon={
                        filters.deliveryPart == part.id && <CheckIcon />
                      }
                      variant={
                        filters.deliveryPart == part.id
                          ? "contained"
                          : "outlined"
                      }
                      color={
                        filters.deliveryPart == part.id
                          ? "secondary"
                          : "primary"
                      }
                      key={part.id}
                      onClick={() => {
                        setOrderModel({ ...orderModel, deliveryPart: part.id });
                        setFilters({ ...filters, deliveryPart: part.id });
                      }}
                    >
                      {part.title}
                    </Button>
                  );
                })}
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: isSmall ? "flex-start" : "center",
              justifyContent: "flex-end",
              flexDirection: isSmall ? "column" : "row",

              gap: 1,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <TextField
                sx={{
                  width: "40%",
                  input: {
                    textAlign: "center",
                  },
                }}
                value={oneOrderSearch ? oneOrderSearch : ""}
                label="سفارش"
                size="small"
                variant="outlined"
                onChange={(evt) => {
                  setOneOrderSearch(evt.target.value);
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    let model = {
                      deliveryDate: filters.deliveryDate,
                      deliveryPart: filters.deliveryPart,
                      orderID: Number(oneOrderSearch),
                    };
                    GetOrderByLogesticId(model, (callback) => {
                      if (callback && callback.id !== 0) {
                        setIsSearch(true);
                        setLocations([callback]);
                        setLocationRout({
                          id: undefined,
                          zoneIndex: undefined,
                        });
                        setOrderModel({
                          ...orderModel,
                          orderID: callback.id,
                        });
                      } else {
                        setLocations([]);
                        setOneOrderSearch("");
                        enqueueSnackbar("سفارشی یافت نشد", {
                          variant: "error",
                          autoHideDuration: 2000,
                          preventDuplicate: true,
                        });
                        return;
                      }
                    });
                  }
                }}
              />
              <Button
                variant="contained"
                onClick={() => {
                  let model = {
                    deliveryDate: filters.deliveryDate,
                    deliveryPart: filters.deliveryPart,
                    orderID: Number(oneOrderSearch),
                  };
                  GetOrderByLogesticId(model, (callback) => {
                    if (callback && callback.id !== 0) {
                      setIsSearch(true);
                      setLocations([callback]);
                      setLocationRout({
                        id: undefined,
                        zoneIndex: undefined,
                      });
                      setOrderModel({
                        ...orderModel,
                        orderID: callback.id,
                      });
                    } else {
                      setLocations([]);
                      setOneOrderSearch("");
                      enqueueSnackbar("سفارشی یافت نشد", {
                        variant: "error",
                        autoHideDuration: 2000,
                        preventDuplicate: true,
                      });
                      return;
                    }
                  });
                }}
              >
                جستجو
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  setOrderModel({
                    ...orderModel,
                    orderID: undefined,
                  });
                  setIsSearch(false);
                  GetLocations(
                    filters.deliveryDate,
                    filters.deliveryPart,
                    (Locations) => {
                      if (Locations) {
                        setOneOrderSearch();
                        setLocations(Locations);
                      } else {
                        setLocations();
                      }
                    },
                    false
                  );
                }}
              >
                همه
              </Button>
            </Box>
            <Button
              sx={{ width: "120px", ml: 2 }}
              color="secondary"
              variant="contained"
              onClick={() => {
                setOpenAutoRout(true);
              }}
            >
              روتینگ هوشمند
            </Button>
          </Box>
        </Box>
        {locations && (
          <Box
            sx={{
              border: "1px solid #cdcdcd",
              borderRadius: 2,
              my: 2,
              flexGrow: 1,
              maxHeight: "90%",
            }}
            display="grid"
            gridTemplateColumns="repeat(12, 1fr)"
            // gap={2}
          >
            <AllRoutsLists
              assigned={assigned}
              setAssigned={setAssigned}
              locationRout={locationRout}
              setLocationRout={setLocationRout}
              routes={routes ? routes : ""}
              orderModel={orderModel}
              setOrderModel={setOrderModel}
              callBack={(model) => {
                GetOrderByLogesticId(model, (callback) => {
                  if (callback) {
                    setOpen({ model: callback, show: true });
                  } else {
                    return;
                  }
                });
              }}
            />
            <AllMapContainer
              routes={routes}
              locationRout={locationRout}
              setLocationRout={setLocationRout}
              locations={locations ?? [35.7009, 51.391241]}
              open={open}
              setOpen={setOpen}
              setOrderDetail={setOrderDetail}
              setOrderModel={setOrderModel}
              orderModel={orderModel}
              changeZoom={changeZoom}
              setChangeZoom={setChangeZoom}
              isSearch={isSearch}
              sendNewLoc={sendNewLoc}
              setSendNewLoc={setSendNewLoc}
              zoneIndex={zoneIndex}
              setZoneIndex={setZoneIndex}
              refreshAllPage={() => {
                refreshPage();
              }}
            />
          </Box>
        )}
      </Box>
    </Detail>
  );
}
